export default __webpack_public_path__ + "static/media/fMaltoBuza41.47b22a00.png";